module.exports = __webpack_public_path__ + "img/la.abeeee00.svg";